import _typeof from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/typeof.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import reportPlugin from '@tencent/vft-report-sdk';
import Vue from 'vue';
import UniversalReport from '@tencent/vft-report-sdk/src/middleware/universal-report';

// 大同数据上报实例
window.universalReporter = new UniversalReport({
  extraParams: function extraParams() {
    return {
      is_vip: window.store && window.store.state.payVip ? window.store.state.payVip.vip : 0
    };
  }
});
var hasWaitReport = false;
// 上报配置
Vue.use(reportPlugin, {
  reporterArr: [new reportPlugin.BossReport({
    pvBoss: {
      attaId: 'z7c00005021',
      token: 1811673448
    },
    eventBoss: {
      attaId: 'z7c00005021',
      token: 1811673448
    },
    presetParam: function () {
      var _presetParam = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var param;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                param = reportPlugin.BossReport.getPresetParam();
                if (hasWaitReport) {
                  _context.next = 11;
                  break;
                }
                _context.prev = 2;
                _context.next = 5;
                return new Promise(function (resolve) {
                  return setTimeout(resolve, 3000);
                });
              case 5:
                _context.next = 10;
                break;
              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](2);
                console.log('wait report error', _context.t0);
              case 10:
                hasWaitReport = true;
              case 11:
                return _context.abrupt("return", Object.assign(param, {
                  f_vip: window.store && window.store.state.payVip ? window.store.state.payVip.vip : 0,
                  f_level: window.store && window.store.state.payVip ? window.store.state.payVip.level : 0
                }));
              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 7]]);
      }));
      function presetParam() {
        return _presetParam.apply(this, arguments);
      }
      return presetParam;
    }()
  })],
  delay: true,
  middlewares: [window.universalReporter]
});

// 从组件或父组件ptag选项里获取ptag
function getPtagFromContext(context) {
  // 通过Vue组件reportModule参数定义组件和子组件的f_module
  if (context.$options['ptag']) {
    return context.$options['ptag'];
  } else if (context.$parent) {
    return getPtagFromContext(context.$parent);
  } else {
    return undefined;
  }
}

// 通过Vue组件ptag定义加入到上报参数中
Vue.mixin({
  created: function created() {
    var _this = this;
    if (_typeof(this.$options['reportData']) === 'object') {
      (function () {
        _this.reportData = _this.$options['reportData'];
        var ptag = getPtagFromContext(_this);
        if (ptag) {
          ptag = 'ad.fuli.' + ptag;
          for (var key in _this.reportData) {
            if (_typeof(_this.reportData[key]) === 'object') {
              if (!_this.reportData[key].f_ptag) {
                _this.reportData[key].f_ptag = ptag;
              }
            } else if (typeof _this.reportData[key] === 'function') {
              (function () {
                var func = _this.reportData[key];
                _this.reportData[key] = function () {
                  var data = func.apply(this, arguments);
                  if (!data.f_ptag) {
                    data.f_ptag = ptag;
                  }
                  return data;
                }.bind(_this);
              })();
            }
          }
        }
      })();
    }
  }
});